require('./RASuitabilityTestReTestBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKButton } = require('commonsComponents/OKButton');

// @utilities
const { formatText } = require('core/i18n').i18n;

// @constants
const { SUITABILITY_TEST_URL } = require('../../../raConstants/index');

class RASuitabilityTestReTestBox extends React.Component {
    constructor() {
        super();
        this.handleReTestButtonClick = this.handleReTestButtonClick.bind(this);
    }

    handleReTestButtonClick() {
        this.props.history.push(SUITABILITY_TEST_URL);
    }

    buildDailyLimitOfTestAttempts() {
        const info = formatText(
            'raSuitabilityTestReTestBox-dailyLimitOfTestAttempts',
        );

        return (
            <article className="ra-suitability-test-retest-box__daily-limit-of-test-attempts-message">
                <p>{info}</p>
            </article>
        );
    }

    render() {
        const { canRepeatTest } = this.props;
        const title = formatText('raSuitabilityTestReTestBox-title');
        const info = formatText('raSuitabilityTestReTestBox-info');
        const btnLabel = formatText('raSuitabilityTestReTestBox-btnLabel');
        const dailyLimitOfTestAttempts = canRepeatTest
            ? null
            : this.buildDailyLimitOfTestAttempts();

        return (
            <ContentBox
                title={title}
                customClassName="ra-suitability-test-valid__content-box ra-suitability-test-valid__content-box--margin ra-suitability-test-retest-box"
            >
                <article className="ra-suitability-test-retest-box__message">
                    <p>{info}</p>
                </article>
                <OKButton
                    onClick={this.handleReTestButtonClick}
                    disabled={!canRepeatTest}
                >
                    {btnLabel}
                </OKButton>
                {dailyLimitOfTestAttempts}
            </ContentBox>
        );
    }
}

RASuitabilityTestReTestBox.propTypes = {
    canRepeatTest: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(RASuitabilityTestReTestBox);
